import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import FadeIn from '../components/FadeIn';
import useBrand from '../hooks/context/useBrand';
import { ScreenEnum } from '../hooks/navigation/Screens';
import { partnerAwarePath } from '../services/branding/partnerSlugStorage';

// routes config
import AuthRoutes from '../routes/AuthRoutes';

const loading = (
  <div className="pt-4 text-center">
    <div className="sk-spinner sk-spinner-pulse" />
  </div>
);

function AuthLayout() {
  const brand = useBrand();

  // Never paint a logged-out screen before the partner brand is known.
  if (!brand?.settled) {
    return loading;
  }

  return (
    <Suspense fallback={loading}>
      <Routes>
        {AuthRoutes.map(
          (route, idx) =>
            route.component && (
              <Route
                key={idx}
                path={route.exact ? route.path : `${route.path.replace(/\/$/, '')}/*`}
                element={
                  <FadeIn>
                    <route.component />
                  </FadeIn>
                }
              />
            ),
        )}
        <Route path="*" element={<Navigate to={partnerAwarePath(ScreenEnum.Login)} replace />} />
      </Routes>
    </Suspense>
  );
}

export default AuthLayout;
